// @flow

import styled from 'styled-components';
import React from 'react';
import PreviewIcon from '../icons/preview';
import Link from './link';
import { colors } from '../constants';

import type { Node } from 'react';

type Props = $ReadOnly<{
  children: Node,
  href: string,
}>;

const StyledLink = styled<{}>(Link)`
  svg {
    margin-left: 4px;
  }
`;

function ExternalLink(props: Props) {
  let { children, href, ...rest } = props;

  return (
    <StyledLink href={href} {...rest} target="_blank" rel="noopener norefferer">
      {children}
      <PreviewIcon color={colors.mediumBlue} size={12} />
    </StyledLink>
  );
}

export default ExternalLink;
